import { createAction, props } from '@ngrx/store';

import {
  LastNotificationsPageStateWithTabs,
  NotificationItem,
} from '@store/notifications/notifications.state';

export const loadNotifications = createAction('[Notifications] Load Notifications');
export const loadNotificationsSuccess = createAction(
  '[Notifications] Load Notifications Success',
  props<{ list: NotificationItem[] }>(),
);
export const loadNotificationsFailure = createAction(
  '[Notifications] Load Notifications Failure',
  props<{ error: string }>(),
);
export const addNotification = createAction(
  '[Notifications] Add new notifications',
  props<{ newNotification: any }>(),
);
export const updateNotificationById = createAction(
  '[Notifications] Update notification by id',
  props<{ updatedNotification: any }>(),
);
export const deleteNotificationById = createAction(
  '[Notifications] Delete notifications by id',
  props<{ deletedNotificationId: any }>(),
);
export const updateIsActiveNotifications = createAction(
  '[Notifications] Update isActive',
  props<any>(),
);

export const setLastPageStateNotifications = createAction(
  '[stateNotifications] Set last page state',
  props<{ newPageState: Partial<LastNotificationsPageStateWithTabs> }>(),
);
